<template>
  <div
    id="app"
    :class="{
      // ako nije na login strani pomera se padding zbog sidebara u zavisnosti od toga da li je prosiren ili ne sidebar
      'sidenav-padding': !sidebarCollapsed && $route.name !== 'login',
      'sidenav-padding-collapsed': sidebarCollapsed && $route.name !== 'login'
    }"
  >
    <sidebar-menu
      v-if="$route.name !== 'login'"
      :collapsed="sidebarCollapsed"
      @collapse="handleCollapse"
    ></sidebar-menu>
    <transition
      appear
      appear-active-class="animated faster fadeIn"
      mode="out-in"
      enter-active-class="animated faster fadeIn"
      leave-active-class="animated faster fadeOut"
    >
      <!--<keep-alive>-->
      <div class="main-wrapper">
        <modal-success-indicator
          v-if="successModal.visible"
        ></modal-success-indicator>
        <modal v-show="modalVisible" />
        <router-view />
      </div>
      <!--</keep-alive>-->
    </transition>
    <!-- <modal-success-indicator v-if="successModal.visible"></modal-success-indicator>
    <modal v-show="modalVisible" />-->
  </div>
</template>

<script>
import SidebarMenu from '@/components/common/TheSidebar';
import Modal from '@/components/modal/Modal';
import ModalSuccessIndicator from '@/components/modal/ModalSuccessIndicator';
import { mapMutations, mapState } from 'vuex';
import axios from '@/axios/axios.js';

export default {
  async mounted() {
    //kad proradi bek
    // navigator.serviceWorker.addEventListener('message', this.flashTitle(e));
    document.addEventListener('visibilitychange', e => {
      if (!document.hidden && this.$router.history.current.name !== 'login') {
        this.$store.dispatch('updateNotifications');

        clearInterval(this.titleInterval);
        this.titleInterval = false;
        document.title = 'Moj komšija';
      }
    });
    if (this.$router.history.current.name !== 'login') {
      this.$store.dispatch('updateNotifications');
    }
    // if (this.$router.history.current.name === 'home') {
    //   this.$store.dispatch('updateNotifications');
    // }
    // poll for new chat messages
    this.refreshInterval = setInterval(() => {
      this.$store.dispatch('updateNumberOfUnreadNotifications');
      this.$store.dispatch('updateNotifications');
    }, 4000);
    this.setRefreshInterval(this.refreshInterval);
    document.addEventListener('keydown', e => {
      switch (e.key) {
        case 'Esc': // IE/Edge specific value
        case 'Escape':
          this.closeModalIfOpen();
      }
    });
  },
  data() {
    return {
      sidebarCollapsed: false,
      title: 'Moj komšija',
      titleInterval: false,
      refreshInterval: null
    };
  },
  computed: {
    ...mapState('modal', ['modalVisible', 'successModal'])
  },
  components: {
    SidebarMenu,
    Modal,
    ModalSuccessIndicator
  },
  methods: {
    ...mapMutations(['setRefreshInterval']),
    ...mapMutations('modal', ['closeModalIfOpen']),

    handleCollapse() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    },
    flashTitle() {
      if (!this.titleInterval) {
        this.titleInterval = setInterval(function() {
          if (document.title === 'Moj komšija') {
            document.title = 'Imate novu notifikaciju';
          } else {
            document.title = 'Moj komšija';
          }
        }, 1500);
      }
    }
  },
  destroyed() {
    clearInterval(this.refreshInterval);
    clearInterval(this.titleInterval);
  }
};
</script>

<style lang="scss">
@import url('https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css');
@import url('https://fonts.googleapis.com/css?family=Montserrat');
@import url('./assets/css/animate.css');
@import url('https://use.fontawesome.com/releases/v5.6.1/css/all.css');

* {
  -webkit-font-smoothing: antialiased;
}

:root {
  --primary-color: #00796b;
  // --primary-color-lighten: rgba(0, 121, 107, 0.8);
  --primary-color-lighten: #008575;
  --danger-color: #dc3545;
}

html,
body,
#app {
  height: 100vh;
  width: 100%;
  font-family: 'Montserrat', sans-serif;
}

#app {
  position: relative;
  transition: padding-left 0.3s;
}

.main-wrapper {
  min-height: 100%;
  position: relative;
}
.txt-pin {
  margin-right: 16px;
}
.toast-bubble {
  background-color: var(--primary-color) !important;
}

.VuePagination__pagination-item-next-chunk,
.VuePagination__pagination-item-prev-chunk {
  display: none;
}

.upload-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px;
}

.upload-icon {
  width: 100%;
  fill: var(--primary-color);
  display: block;
  margin-bottom: 8px;
}

.upload-text {
  width: 100% !important;
  text-align: center;
  color: var(--primary-color);
}

.upload-more-wrapper {
  padding: 4px;
  border-bottom: none;
  font-size: 15px;
  width: 100%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.upload-more-icon {
  width: 20%;
  fill: var(--primary-color);
  display: block;
}

.upload-more-text {
  width: 80%;
  text-align: center;
  color: var(--primary-color);
}

.mandatory {
  color: red;
}

.email-upload-more-wrapper {
  padding: 4px;
  border-bottom: none;
  font-size: 15px;
  width: 100%;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: flex;
  vertical-align: center;
  align-items: center;
  justify-content: center;
  svg {
    fill: var(--primary-color);
    margin-right: 8px;
  }
  span {
    color: var(--primary-color);
  }
}

.document-name,
.document-name:hover {
  color: var(--primary-color);
  font-weight: bold;
}

.textarea-error {
  border-color: #c82333 !important;
}
.textarea-error:focus {
  box-shadow: 0 0 0 0.1rem #c82333 !important;
  border-color: #c82333 !important;
}
.character-counter-error {
  color: #c82333;
}
.textarea-wrapper {
  width: 100%;
  textarea {
    padding-right: 55px;
  }
}

.character-counter {
  position: absolute;
  bottom: 21px;
  font-size: 0.8rem;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}

.label-phone-number {
  padding-bottom: 0;
}
.phone-number-explainer {
  font-size: 0.7em;
  color: #999;
}
.btn {
  .vue-simple-spinner {
    height: 20px !important;
    width: 20px !important;
  }
}

.btn-primary {
  background-color: var(--primary-color);
  border: none;
  // margin: 2px;
}

.btn-primary:disabled {
  background-color: var(--primary-color-lighten);
}

.btn-danger {
  margin-right: 4px;
}

.btn-primary:hover {
  background-color: var(--primary-color-lighten);
}

.btn-primary:active {
  background-color: var(--primary-color) !important;
  border: none !important;
  box-shadow: none !important;
}

.btn-primary:focus {
  box-shadow: none;
}

tr {
  cursor: pointer;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
  .col-md-12 {
    padding-right: 0;
    padding-left: 0;
  }
}

.form-group.form-inline.VueTables__search {
  float: right;
}

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.1rem var(--primary-color);
}

.pull-right {
  float: right;
}

.VueTables__limit {
  display: none;
}

.sidenav-padding-collapsed {
  padding-left: 50px;
}

.sidenav-padding {
  // padding-left: 350px !important;
  padding-left: 18vw !important;
}

::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
  background: var(--primary-color) !important;
}

.vdatetime-popup {
  top: 17% !important;
  transform: translate(-50%, 0) !important;
}

.vdatetime-popup__actions__button {
  color: var(--primary-color) !important;
}

.vdatetime-time-picker__item--selected {
  color: var(--primary-color) !important;
}

.vdatetime-popup__header {
  background: var(--primary-color) !important;
}

.print_opt {
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 5px;
    cursor: pointer;
    font-size: 18px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the radio button is checked, add a blue background */
  .container input:checked ~ .checkmark {
    background-color: var(--primary-color);
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the indicator (dot/circle) when checked */
  .container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the indicator (dot/circle) */
  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
}

.ui.fluid.search {
  width: 100%;
  line-height: 1.5;
  border-radius: 0.3rem;
  border: 1px solid #ced4da;
  font-size: 0.9rem;
  color: inherit;
  transition: 0.2s all;
  height: calc(2.875rem + 2px);

  input {
    border: none;
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    max-width: 100%;
    width: 100%;
    border-radius: 0.3rem;
  }

  input:focus {
    border: none;
    outline: none;
    & {
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
  .text {
    position: absolute;
    top: 12px;
    left: 1rem;
    color: inherit;
    font-size: 1rem;

    max-height: 26px;
    max-width: calc(100% - 15px);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .text.default {
    color: #999 !important;
  }
  .menu {
    position: relative;
    border: 1px solid #ced4da;
    border-radius: 0.3rem;
    border-top-width: 0;
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    z-index: 11;
    background-color: white;
    max-height: 10rem;
    overflow-y: auto;
    margin: -2px -1px;
    .item {
      z-index: 15;
      padding: 4px 6px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      &:first-child {
        border-top: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
    .item:hover {
      background-color: rgba(0, 0, 0, 0.05);
      cursor: pointer;
    }

    .item.selected {
      background-color: rgba(0, 0, 0, 0.178);
    }
  }
}
.pointer-cursor {
  cursor: pointer;
}

// Sets appropriate dropdown arrow for select.custom-select bootstrap class
.custom-select {
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3e%3cpath d='M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z'/%3e%3c/svg%3e");
}
.custom-tooltip {
  margin-left: 8px;
  color: var(--primary-color);
  position: relative;
}
.custom-tooltip .tooltiptext {
  visibility: hidden;
  width: 200px;
  background-color: var(--primary-color);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  margin-left: -98px;
  font-size: 1rem;
}

.custom-tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
